/* ============================================================
   Wido Ops — manager drill-in: a team member's full dashboard.
   Exports window.EmployeeDetailScreen.
   ============================================================ */
(function () {
  const D = window.WidoData;
  const AV = window.WidoAvatar;

  function buildMonth(person, settings) {
    const base = D.helpers.timesheetMonth(person.id, D.CUR_YEAR || 2026, D.CUR_MONTH || 6, settings);
    const s = D.companyStats.find((x) => x.person.id === person.id);
    const taken = s && s.leaveDays != null ? s.leaveDays : 0;
    const offsetDays = (s && s.offsetDays) || base.offsetDays || 0;
    return Object.assign({}, base, {
      leaveDays: taken,
      offsetMin: (s && s.offsetMin) || base.offsetMin || 0,
      offsetDays,
      overtimeMin: (s && s.overtimeMin) || base.overtimeMin || 0,   // weekend OT -> Hours summary
      hasDaily: D.helpers.dailyActive(person.id, settings),
      // Offset days lower the balance like a leave day (kept out of leaveDays).
      leave: D.helpers.computeLeave(person.id, settings, (taken || 0) + offsetDays, person),
    });
  }

  function EmployeeDetailScreen({ person, settings, t, viewer, onBack, onNav }) {
    if (!person) return null;
    const month = buildMonth(person, settings);
    const leader = D.helpers.leaderOf(person);
    return React.createElement("div", { className: "stack-v", style: { gap: 22 } },
      React.createElement("button", { className: "btn btn--text btn--sm", style: { alignSelf: "flex-start" }, onClick: onBack },
        React.createElement("span", { className: "material-symbols-rounded" }, "arrow_back"), "Back"),
      // person header
      React.createElement("div", { className: "card card--pad" },
        React.createElement("div", { className: "between wrap", style: { gap: 16 } },
          React.createElement("div", { className: "row", style: { gap: 16, minWidth: 0 } },
            React.createElement("div", { className: "avatar avatar--lg", style: { background: AV.color(person.name) } }, AV.initials(person.name)),
            React.createElement("div", { className: "stack-v", style: { gap: 3, minWidth: 0 } },
              React.createElement("h2", { className: "section-title", style: { fontSize: 24 } }, person.name),
              React.createElement("span", { className: "muted" }, person.title + " · " + D.helpers.teamName(person.team)),
              React.createElement("div", { className: "row", style: { gap: 8, flexWrap: "wrap", marginTop: 4 } },
                React.createElement("span", { className: "tag tag--neutral" }, D.helpers.roleName(person.roleId)),
                leader && React.createElement("span", { className: "tag tag--neutral" }, React.createElement("span", { className: "material-symbols-rounded" }, "supervisor_account"), "Reports to " + leader.name),
                React.createElement("span", { className: "tag tag--neutral mono" }, "Joined " + D.helpers.fmtDate(D.helpers.currentStart(person)))))),
          React.createElement("div", { className: "row", style: { gap: 8 } },
            // Use the person's account status, not isEmployed(): the drill-in person
            // comes from companyStats, where `periods` is nulled, so isEmployed would
            // always read false ("Inactive") for genuinely active employees.
            React.createElement("span", { className: "tag " + (person.status === "active" ? "tag--ok" : "tag--err") }, person.status === "active" ? "Active" : "Inactive"))),
      ),
      // read-only dashboard
      React.createElement(window.Dashboard, { t, me: person, month, onNav: onNav || (() => {}), readOnly: true, settings }),
      // historical timesheet (table only — the Dashboard above already shows the
      // "Late minutes per day" + "Deduction breakdown" charts, so suppress the dupes)
      React.createElement(window.TimesheetScreen, { person, settings, title: person.name.split(" ").slice(-1)[0] + "'s timesheet", hideCharts: true }),
    );
  }

  window.EmployeeDetailScreen = EmployeeDetailScreen;
})();
